import React, { useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { getProductsSaga } from './saga'
import injectSaga from '../../utils/injectSaga'
import { getProducts } from '../App/actions'

const REFRESH_INTERVAL = 10 * 60 * 60 * 1000

const ProductsLoader = () => {
  const dispatch = useDispatch()
  const products = useSelector(state => state.toJS().global.products)
  const agencytoken = useSelector(state => state.toJS().global.agencytoken)

  useEffect(() => {
    if (products == null && agencytoken != null) {
      dispatch(getProducts())
    }
  }, [products, agencytoken])

  // Les URLs des médias signées par tgd-api expirent après 12 h : on les renouvelle avant
  useEffect(() => {
    if (agencytoken == null) return
    const timer = setInterval(() => dispatch(getProducts()), REFRESH_INTERVAL)
    return () => clearInterval(timer)
  }, [agencytoken])

  return <div />
}

const withConnect = connect(null, null)
const withSaga = injectSaga({ key: 'ProductsLoader', saga: getProductsSaga })
export default compose(withSaga, withConnect)(ProductsLoader)
